import { useEffect } from "react"
import { useAtomValue } from "jotai"
import { trackingPreferencesAtom } from "app/state"
import * as Sentry from "@sentry/react"
import { dropExpectedAuthErrors } from "./observability.utils"
let replayInstance: ReturnType<typeof Sentry.replayIntegration> | null = null

const Observability = () => {
  const preferences = useAtomValue(trackingPreferencesAtom)

  useEffect(() => {
    if (Sentry.isInitialized() || !preferences?.analytics) return

    const sentryDsn = process.env.SENTRY_DSN
    if (sentryDsn) {
      replayInstance = Sentry.replayIntegration()
      Sentry.init({
        dsn: sentryDsn,
        environment: process.env.TES_ENV || "local",
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.browserProfilingIntegration(),
          Sentry.replayCanvasIntegration(),
          replayInstance,
        ],
        tracesSampleRate: 0.5,
        profileSessionSampleRate: 0.5,
        profileLifecycle: "trace",
        beforeSend: dropExpectedAuthErrors,
        // Don't auto-start replays — we control start/stop based on consent
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      })
    }
  }, [preferences?.analytics])

  // Start/stop session replay based on user consent
  useEffect(() => {
    const replay = replayInstance
    if (!replay) return
    // consider adding a sample rate for replays
    // right now we record 100% of users who consent
    if (preferences?.sessionReplay) {
      replay.start()
    } else {
      replay.stop()
    }
  }, [preferences?.sessionReplay])

  return null
}

export default Observability
